export default __webpack_public_path__ + "static/media/Group 750.93ae61a1.jpg";